<template>
  <div class="row">
    <div class="card-header">
      <h4 class="title">Suche nach Name, Email oder Id</h4>
    </div>
    <div class="col-md-12">
    </div>
    <div class="col-md-12 card">
      <div class="card-content row">
        <div class="col-sm-6">
          <div class="pull-left" style="width: 100%;">
            <label style="width: 100%;">
              <input type="search" v-on:keyup.enter="onKeydown" class="form-control input-sm" placeholder="Suche..." v-model="searchQuery" aria-controls="datatables">
            </label>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="pull-left">
            <button class="btn btn-default btn-fill btn-wd" @click="searchUser">Suchen</button>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="pull-right">
            <!-- <button class="btn btn-default btn-fill btn-wd" @click="addUser">Benutzer hinzufügen</button> -->
          </div>
        </div>
        <div class="col-sm-12">
          <el-table class="table-striped"
                    :data="queriedData"
                    @row-click="rowClicked"
                    border
                    style="width: 100%">
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :align='column.align'
                             :class-name='column.class'
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
            <!--
            <el-table-column
              :min-width="60"
              fixed="right"
              label="Actions">
              <template slot-scope="props">
                <a class="btn btn-simple btn-xs btn-warning btn-icon edit" @click="handleEdit(props.$index, props.row)"><i class="ti-pencil-alt"></i></a>
                <a class="btn btn-simple btn-xs btn-danger btn-icon remove"  @click="handleDelete(props.$index, props.row)"><i class="ti-close"></i></a>
              </template>
            </el-table-column>
            -->
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">{{from + 1}} bis {{to}} von {{total}}</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import users from './users'
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
    computed: {
      userData () {
        return this.$store.state.users
      },
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              if (row[key] === undefined || row[key] === null) {
                continue
              }
              let rowValue = row[key].toString().toLowerCase()
              if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.$store.state.users.length
        return this.$store.state.users.length
        // this.pagination.total = this.tableData.length
        // return this.tableData.length
      },
      tableData () {
        return this.$store.state.users
      }
    },
    data () {
      return {
        pagination: {
          perPage: 50,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['id', 'nickname', 'email', 'source', 'status'],
        tableColumns: [
          {
            prop: 'id',
            label: 'Id',
            minWidth: 60,
            align: 'left',
            class: 'id-column'
          },
          {
            prop: 'nickname',
            label: 'Name',
            minWidth: 130
          },
          {
            prop: 'email',
            label: 'Email',
            minWidth: 170
          },
          {
            prop: 'source',
            label: 'Source',
            minWidth: 80
          },
          {
            prop: 'status',
            label: 'Status',
            minWidth: 80
          }
        ]
      }
    },
    beforeCreate () {
      this.$log.debug('UsersTable.beforeCreate')
      this.searchQuery = ''
      this.$store.dispatch('clearUsers', '')
    },
    created () {
      this.$log.debug('UsersTable.created')
    },
    mounted () {
      this.$log.debug('UsersTable.mounted')
    },
    methods: {
      onKeydown(event) {
        if (event.keyCode === 13) {
          this.searchUser()
        }
      },
      searchUser () {
          this.$store.dispatch('fetchUsers', this.searchQuery).then(function () {

          });
      },
      rowClicked (rowdata) {
        this.$log.debug('rowClicked ' + JSON.stringify(rowdata))
        this.$router.push('user/' + rowdata.id)
      },
      addUser () {
        alert('Benutzer hinzufügen')
        //this.$router.push('user/0')
      },
      handleEdit (index, row) {
        // alert(`Edit ${row.nickname}`)
        this.$router.push('user/' + row.id)
      },
      handleDelete (index, row) {
        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
        if (indexToDelete >= 0) {
          var r = confirm('Benutzer ' + row.nickname + ' (' + row.email + ') löschen?')
          if (r === true) {
            this.$store.dispatch('updateUser', {
              id: row.id,
              content: {
                status: 'inactive'
              }
            }).then(() => {
              this.tableData.splice(indexToDelete, 1)
            })
          }
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Tables/UsersTable.vue